import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Payment as PaymentIcon } from "@mui/icons-material";
import { History as HistoryIcon } from "@mui/icons-material";
import { useAuth } from "../../contexts/AuthContext";
import RecentTransactions from "../../components/RecentTransactions";

const Dashboard = () => {
  const navigate = useNavigate();
  const user = useAuth();
  const { system } = useAuth();

  const handlePaymentClick = () => {
    if (system === "sisfuner") {
      navigate("/payment/sisfuner");
    } else {
      navigate("/payment/gscemi");
    }
  };

  const handleHistoryClick = () => {
    navigate("/transactions-history");
  };

  return (
    <Box>
      <Typography variant="body2" component="span">
        POS: {user?.user?.tef?.Descricao}
        {" :: "}
      </Typography>
      <Typography variant="body1" component="span">
        {user?.user?.tef?.SerialNumber}
      </Typography>

      {/* <pre>{JSON.stringify(user, null, 2)}</pre> */}
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" component="div" gutterBottom>
                Efetuar Pagamento
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Realize pagamentos de parcelas pendentes no sistema.
              </Typography>
              <Button
                variant="contained"
                startIcon={<PaymentIcon />}
                onClick={handlePaymentClick}
              >
                Efetuar Pagamento
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Typography variant="h6" component="div" gutterBottom>
                Últimas Transações
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Verifique o histórico de transações realizadas no sistema.
              </Typography>
              <RecentTransactions />
              <Button
                variant="contained"
                startIcon={<HistoryIcon />}
                onClick={handleHistoryClick}
              >
                Ver Histórico completo
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
